// useMonthNavigator.js
import { useCallback } from 'react';
import { addMonths, getMonth, isSameMonth } from 'date-fns';

/**
 * useMonthNavigator Hook
 * Manages month navigation logic and provides functions for previous, next, and current months.
 *
 * @param {Object} calendar - Contains setCurrentMonth, currentMonth, setSelectedDate.
 * @returns {Object} - Contains functions for navigating months.
 */
export const useMonthNavigator = ({ setCurrentMonth, currentMonth, setSelectedDate }) => {
  const handleMonthChange = useCallback(
    (monthsToAdd) => {
      setSelectedDate((prevDate) => {
        const newDate = addMonths(prevDate, monthsToAdd); 
        // Update currentMonth only if it changes
        if (!isSameMonth(newDate, currentMonth)) {
          setCurrentMonth(newDate);
        }

        return newDate;
      });
    },
    [currentMonth, setCurrentMonth, setSelectedDate]
  );

  return {
    goToPreviousMonth: () => handleMonthChange(-1),
    goToNextMonth: () => handleMonthChange(1),
    goToToday: () => {
      const today = new Date();
      setCurrentMonth(today);
      setSelectedDate(today);
    },
  };
};
